// `isClickTrackingVerified` is added to GET .../verificationStatus by the API half of
// this split. Until that deploys the field is absent, so fall back to the record the
// API derives it from - reading an absent field as "not verified" would disable
// campaign activation for every domain in the window between the two releases.
// Returns undefined when the status is not loaded (or is too old to say), which
// callers treat as "not known yet" rather than as a failure.
const clickTrackingVerified = (verificationStatus) =>
  verificationStatus?.isClickTrackingVerified ?? verificationStatus?.releva?.resources?.valid;

export default clickTrackingVerified;
